// Date Formatters and Utility Functions

import {
  addDays,
  addWeeks,
  endOfWeek,
  formatDistance,
  parseISO,
  subDays,
  subWeeks,
} from "date-fns";
import { format, parse, startOfWeek } from "date-fns";
import { defineds } from "utils/datepicker-util/app-constants/DateDefineds";
import { startofweek } from "../app-constants/TTAIWeekDate";
import { func } from "prop-types";
import { NOT_AVAILABLE } from "store/constant";
// import { startofweek } from 'utils/app-constants/TTAIWeekDate';

export function dateToStringRaw(inDateStr, inFormat, outFormat) {
  return format(parse(inDateStr.slice(0, 10), inFormat, new Date()), outFormat);
}

export function ttaiDateToString(dateStr, dateFormat) {
  return dateToStringRaw(dateStr, "yyyy-MM-dd", dateFormat);
}

export function ttaiFormatDateRaw(date, dateFormat) {
  return format(date, dateFormat);
}
// 23%2F11%2F2023
export function ttaiAPIFormatDate(date) {
  const formattedDate = ttaiFormatDate(date, "dd-MM-yyyy");
  return formattedDate.replace(/-/g, "%2F");
}

export function ttaiAPIFormatDate2(date) {
  const formattedDate = ttaiFormatDate(date, "dd/MM/yyyy");
  return formattedDate.replace(/-/g, "%2F");
}

export function HDDisplayFormatDate(date) {
  console.log(date)
  const formattedDate = ttaiFormatDate(date, "MM-dd-yyyy");
  console.log("formattedDate",formattedDate)
  return formattedDate.replace(/-/g, "%2F");
}

export const hdFormatDateToDDMMYYYY = (date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

// export function HireDrateApiFormat()

export function ttaiFormatDate(date, dateFormat) {
  if (date != null) {
    return ttaiFormatDateRaw(date, dateFormat);
  } else {
    return dateFormat;
  }
}

// Function to parse date in DD/MM/YYYY, HH:mm:ss format
export function hdParseCustomDate(dateString) {
  const [datePart, timePart] = dateString.split(", ");
  const [day, month, year] = datePart.split("/").map(Number);
  const [hours, minutes, seconds] = timePart.split(":").map(Number);
  return new Date(year, month - 1, day, hours, minutes, seconds);
}

export function hdParseServerTimeStamp(dateString) {
  const [datePart, timePart] = dateString.split(" ");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hours, minutes, seconds] = timePart.split(":").map(Number);
  return new Date(year, month - 1, day, hours, minutes, seconds);
}

export function hdParseServerTimeStampMailMessage(dateString) {
  const [datePart, timePart] = dateString.split(" ");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hours, minutes, seconds] = timePart.split(":").map(Number);

  return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
}

export function hdParseServerTimeStampForUTC(dateString) {
  const [datePart, timePart] = dateString.split(" ");
  const [year, month, day] = datePart.split("-").map(Number);
  const [hours, minutes, seconds] = timePart.split(":").map(Number);
  return new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds)); 
}

export function formatDateDistanceForTimeStamp(dateStamp) {
  const dateObject = parseISO(dateStamp);

  const formattedDate = formatDistance(dateObject, new Date(), {
    addSuffix: true,
  });
  return formattedDate;
}

export function formatDateDistance(dateStamp) {
  const dateObject = hdParseServerTimeStamp(dateStamp);
  const formattedDate = formatDistance(dateObject, new Date(), {
    addSuffix: true,
  });
  return formattedDate;
}

export function formatDateDistanceFromUTCToLocal(dateStamp) {
  const utcDate = hdParseServerTimeStampForUTC(dateStamp);  
  const now = new Date();                             
  return formatDistance(utcDate, now, { addSuffix: true }); 
}

export function formatMADate(dateStamp) {
  const parsedDate = parseISO(dateStamp);
  const formattedDate = format(parsedDate, "yyyy-MM-dd HH:mm:ss");
  return formattedDate;
}

export function getLocalTimeStamp() {
  return new Date().toLocaleString();
}

export function getUTCTimeStamp() {
  return new Date().toISOString();
}

export function getOrgListDateRange() {
  // const listFromDate = defineds.startOfLast30Days;
  // const listToDate = defineds.endOfToday;
  return [defineds.startOfLast30Days, defineds.endOfToday];
}

export function getWeekRange(orgPreferenceData, selection, weekData) {
  var start,
    end,
    day,
    endofweek,
    days = [],
    finalObj;
  let week_day;
  if (orgPreferenceData.length === 0) {
    week_day = 1;
  } else {
    let datelangstart = orgPreferenceData.response.data[0].startOfWeek;
    startofweek.forEach((element) => {
      if (datelangstart === element.shortname) {
        week_day = element.weekday;
      }
    });
  }
  const weekInit = (dateObj) => {
    start = startOfWeek(dateObj, { weekStartsOn: week_day });
    end = endOfWeek(start, { weekStartsOn: week_day });
    day = start;
    endofweek = end;
    while (day <= endofweek) {
      days.push(day);
      day = addDays(day, 1);
    }
    finalObj = [
      {
        weekRange: {
          start: ttaiFormatDateRaw(start, "yyyy-MM-dd"),
          end: ttaiFormatDateRaw(end, "yyyy-MM-dd"),
          weekDays: days,
        },
      },
    ];
  };
  if (selection === "this") {
    weekInit(new Date());
  } else if (selection === "next") {
    weekInit(addWeeks(new Date(weekData[0].weekRange.start), 1));
  } else if (selection === "back") {
    weekInit(subWeeks(new Date(weekData[0].weekRange.start), 1));
  }

  return finalObj;
}

export function getDayRange(selection, dayData) {
  var finalObj;
  if (selection === "this") {
    finalObj = new Date();
  } else if (selection === "next") {
    finalObj = addDays(new Date(dayData), 1);
  } else if (selection === "back") {
    finalObj = subDays(new Date(dayData), 1);
  }

  return ttaiFormatDateRaw(finalObj, "yyyy-MM-dd");
}

export function toHHMM(secs) {
  var sec_num = parseInt(secs, 10);
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor(sec_num / 60) % 60;

  return [hours, minutes]
    .map((v) => (v < 10 ? "0" + v : v))
    .filter((v, i) => v !== "00" || i > 0)
    .join(":");
}

export function getWeekDateRange() {
  return [defineds.startOfWeek, defineds.endOfWeek];
}

export function ttaiFormatInvoiceDate(date) {
  if (date !== undefined) {
    return date.slice(0, 10);
  }
}

export function formatDurationDate(fromDate, toDate) {
  if (fromDate === null && toDate === null) {
    return NOT_AVAILABLE;
  } else if (fromDate !== null && toDate === null) {
    const fromDateObj = new Date(fromDate);
    const formattedDate = format(fromDateObj, "MM/yyyy");
    return (
      <>
        {/* {formattedDate} - As of Date */}
        <span>
          {formattedDate} <span style={{ margin: "0 4px" }}>-</span> As of Date
        </span>
      </>
    );
  } else if (
    fromDate !== null &&
    fromDate !== "" &&
    toDate !== null &&
    toDate !== ""
  ) {
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);
    const formattedFromDate = format(fromDateObj, "MM/yyyy");
    const formattedToDate = format(toDateObj, "MM/yyyy");
    return (
      <span>
        {formattedFromDate} <span style={{ margin: "0 4px" }}>-</span>{" "}
        {formattedToDate}
      </span>
    );
  } else if (fromDate === null && toDate !== null) {
    const toDateObj = new Date(toDate);
    const formattedDate = format(toDateObj, "MM/yyyy");
    return (
      <span>
        {NOT_AVAILABLE}
        {" - "} {formattedDate}
      </span>
    );
  } else {
    return NOT_AVAILABLE;
  }
}

export const defaultSelectedFromDate=()=>{
  return new Date(defineds.startOfLast2Week)
}

export const defaultSelectedToDate=()=>{
  return new Date(defineds.startOfToday)

}